<app-customer-details></app-customer-details>